import { Controller, useFormContext } from "react-hook-form"
import InputTextSuggestions, {
    InputTextSuggestion,
} from "src/shared/components/forms/input-text-suggestions/InputTextSuggestions"
import accountBoxFill from "src/shared/icons/accountBoxFill"
import FormSection from "../../components/FormSection/FormSection"
import FormSectionRow from "../../components/FormSectionRow/FormSectionRow"
import { DefaultValuesType } from "../../VentaHabitacion.types"

// Colaborador que recibió las propinas capturadas en el pago mixto
const PropinaMixto = ({ colaboradoresSuggestions }: { colaboradoresSuggestions: InputTextSuggestion[] }) => {
    const { control } = useFormContext<DefaultValuesType>()

    return (
        <FormSection title="Propina">
            <FormSectionRow>
                <Controller
                    control={control}
                    name="colaboradorRecibioPropina"
                    rules={{
                        required: true,
                        validate: (v) => !!v?.id && !!v?.title,
                    }}
                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <InputTextSuggestions
                            suggestionsListWidth="255px"
                            suggestions={colaboradoresSuggestions}
                            value={value || ""}
                            inputTextConfig={{
                                inputWrapperClass: "venta-habitacion-input",
                                label: "¿Quién recibió la propina?",
                                placeholder: "Nombre del personal",
                                type: "text",
                                icon: accountBoxFill,
                                error: !!error,
                                errorhinttext: error?.type === "validate" ? "Escribe el nombre del responsable" : "",
                            }}
                            onChange={onChange}
                        />
                    )}
                />
            </FormSectionRow>
        </FormSection>
    )
}

export default PropinaMixto
